/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DucCriteriaDto } from '../models/duc-criteria-dto';
import { DucDto } from '../models/duc-dto';
import { DucPageDto } from '../models/duc-page-dto';
import { DucsPedidoDto } from '../models/ducs-pedido-dto';


/**
 * Ducs
 */
@Injectable({
  providedIn: 'root',
})
export class DucsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getDucsPedido
   */
  static readonly GetDucsPedidoPath = '/duc';

  /**
   * Pesquisar DUCS Pedido.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDucsPedido()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDucsPedido$Response(params?: {
    criteriaDto?: DucCriteriaDto;
  }): Observable<StrictHttpResponse<DucPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, DucsService.GetDucsPedidoPath, 'get');
    if (params) {
      rb.query('criteriaDto', params.criteriaDto, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DucPageDto>;
      })
    );
  }

  /**
   * Pesquisar DUCS Pedido.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDucsPedido$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDucsPedido(params?: {
    criteriaDto?: DucCriteriaDto;
  }): Observable<DucPageDto> {

    return this.getDucsPedido$Response(params).pipe(
      map((r: StrictHttpResponse<DucPageDto>) => r.body as DucPageDto)
    );
  }

  /**
   * Path part for operation getDuc
   */
  static readonly GetDucPath = '/duc/{tipoPedido}/{numPedido}';

  /**
   * get duc.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDuc()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDuc$Response(params: {
    tipoPedido: string;
    numPedido: string;
  }): Observable<StrictHttpResponse<DucsPedidoDto>> {

    const rb = new RequestBuilder(this.rootUrl, DucsService.GetDucPath, 'get');
    if (params) {
      rb.path('tipoPedido', params.tipoPedido, {});
      rb.path('numPedido', params.numPedido, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DucsPedidoDto>;
      })
    );
  }

  /**
   * get duc.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDuc$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDuc(params: {
    tipoPedido: string;
    numPedido: string;
  }): Observable<DucsPedidoDto> {

    return this.getDuc$Response(params).pipe(
      map((r: StrictHttpResponse<DucsPedidoDto>) => r.body as DucsPedidoDto)
    );
  }

  /**
   * Path part for operation getCobrancaDuc
   */
  static readonly GetCobrancaDucPath = '/duc/{tipoPedido}/{numPedido}/cobranca';

  /**
   * get cobrança duc.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCobrancaDuc()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCobrancaDuc$Response(params: {
    tipoPedido: string;
    numPedido: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, DucsService.GetCobrancaDucPath, 'get');
    if (params) {
      rb.path('tipoPedido', params.tipoPedido, {});
      rb.path('numPedido', params.numPedido, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * get cobrança duc.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCobrancaDuc$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCobrancaDuc(params: {
    tipoPedido: string;
    numPedido: string;
  }): Observable<Blob> {

    return this.getCobrancaDuc$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation getReciboDuc
   */
  static readonly GetReciboDucPath = '/duc/{tipoPedido}/{numPedido}/recibo';

  /**
   * get recibo duc.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReciboDuc()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReciboDuc$Response(params: {
    tipoPedido: string;
    numPedido: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, DucsService.GetReciboDucPath, 'get');
    if (params) {
      rb.path('tipoPedido', params.tipoPedido, {});
      rb.path('numPedido', params.numPedido, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * get recibo duc.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getReciboDuc$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReciboDuc(params: {
    tipoPedido: string;
    numPedido: string;
  }): Observable<Blob> {

    return this.getReciboDuc$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation simularReemissaoDuc
   */
  static readonly SimularReemissaoDucPath = '/duc/{tipoPedido}/{numPedido}/reemitir';

  /**
   * simulação da reemissão de um DUC.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `simularReemissaoDuc()` instead.
   *
   * This method doesn't expect any request body.
   */
  simularReemissaoDuc$Response(params: {
    tipoPedido: string;
    numPedido: string;
  }): Observable<StrictHttpResponse<DucDto>> {

    const rb = new RequestBuilder(this.rootUrl, DucsService.SimularReemissaoDucPath, 'get');
    if (params) {
      rb.path('tipoPedido', params.tipoPedido, {});
      rb.path('numPedido', params.numPedido, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DucDto>;
      })
    );
  }

  /**
   * simulação da reemissão de um DUC.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `simularReemissaoDuc$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  simularReemissaoDuc(params: {
    tipoPedido: string;
    numPedido: string;
  }): Observable<DucDto> {

    return this.simularReemissaoDuc$Response(params).pipe(
      map((r: StrictHttpResponse<DucDto>) => r.body as DucDto)
    );
  }

  /**
   * Path part for operation reemitirDuc
   */
  static readonly ReemitirDucPath = '/duc/{tipoPedido}/{numPedido}/reemitir';

  /**
   * reemitir duc.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reemitirDuc()` instead.
   *
   * This method doesn't expect any request body.
   */
  reemitirDuc$Response(params: {
    tipoPedido: string;
    numPedido: string;
  }): Observable<StrictHttpResponse<DucDto>> {

    const rb = new RequestBuilder(this.rootUrl, DucsService.ReemitirDucPath, 'post');
    if (params) {
      rb.path('tipoPedido', params.tipoPedido, {});
      rb.path('numPedido', params.numPedido, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DucDto>;
      })
    );
  }

  /**
   * reemitir duc.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reemitirDuc$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reemitirDuc(params: {
    tipoPedido: string;
    numPedido: string;
  }): Observable<DucDto> {

    return this.reemitirDuc$Response(params).pipe(
      map((r: StrictHttpResponse<DucDto>) => r.body as DucDto)
    );
  }

}
